import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  label: {
    '& .MuiTreeItem-label': {
      fontSize: spacing(16),
      lineHeight: spacing(20),
      fontFamily: 'Roboto',
      fontWeight: 'normal',
    },
  },
}))
